var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "mku-options-group" },
    [
      _vm.label
        ? _c(
            "div",
            {
              staticClass: "mku-options-group__title",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.handleClick($event)
                }
              }
            },
            [_vm._t("title", [_vm._v(_vm._s(_vm.label))])],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }